import {
    Bold, ContentButton,
    ContentDescription, ContentSubDescription,
    ContentSubTitle, Description, StatusSubscription, SubTitle
} from "@dropDesk/presentation/pages/subscription/ui/detail_subscription/styled";
import ButtonMain from "@dropDesk/presentation/components/buttons/button_main";
import React from "react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {SharedColors} from "@dropDesk/domain/entities/theme/app_colors";

const DetailFreePlan = (
    {
        disabled,
        loading,
        onClickSelectPlan,
        planName,
        nextDueDateDDMMYYYY,
        daysToExpireSubs
    }: {
        disabled: boolean;
        loading: boolean;
        onClickSelectPlan: () => void
        planName: string;
        nextDueDateDDMMYYYY: string;
        daysToExpireSubs: number;
    }
) => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <>
            <ContentDescription>
                <ContentSubTitle>
                    <SubTitle color={colors.text}>{planName}</SubTitle>
                    <StatusSubscription
                        background={colors.success}
                        color={SharedColors.white}
                    >ATIVO</StatusSubscription>
                </ContentSubTitle>
                <ContentSubDescription>
                    <Description size={15} color={colors.text}>Vencimento do plano:
                        <Bold>&nbsp;{nextDueDateDDMMYYYY}</Bold>
                    </Description>
                    <Description size={15} color={colors.textError}>O seu teste gratuito
                        {daysToExpireSubs >= 0 && <Bold>&nbsp;termina em&nbsp;{daysToExpireSubs} dias</Bold>}
                        {daysToExpireSubs < 0 && <Bold>&nbsp;terminou</Bold>}
                    </Description>
                </ContentSubDescription>
            </ContentDescription>
            <ContentButton>
                <ButtonMain
                    style={{paddingLeft: 5, paddingRight: 5}}
                    widthPercentage={100}
                    letterFontSize={15}
                    height={35}
                    disabled={disabled}
                    loading={loading}
                    color={colors.accent}
                    type={"submit"}
                    letter={'Assinar agora'}
                    onClick={() => onClickSelectPlan()}
                />
            </ContentButton>
        </>
    )
}
export default DetailFreePlan;
